// extracted by mini-css-extract-plugin
export default {"container":"ModelParameters-module__container--cl4I1"};